export const BadgeCircleComponent = {
  bindings: {
    state: '<',
    color: '<',
    size: '<',
    showStatus: '<',
  },
  templateUrl: 'components/badge-circle/badge-circle.html',
};
